<template>
    <div class="list row">
        <h2>Ovlašćenja</h2>
        <div class="actions d-flex flex-row-reverse">
            <button type="button" class="btn btn-primary bi bi-arrow-clockwise" @click="refreshData" />
            <button type="button" class="btn btn-success bi bi-plus" @click="addData" />
        </div>
        <data-table url="authorization" :columns="columns" :templates="templates" :headings="headers" :actions="actions"
            ref="datatable" @yes="deleteData" name="Authorization">
        </data-table>
    </div>
</template>

<script>
import AuthorizationDataService from "../../services/authorization.service";
import DataTable from "../widgets/DataTable.vue";

export default {
    name: "authorization",
    components: {
        DataTable,
    },
    data() {
        return {
            columns: ["id", "authorized.full_name", "registration_nr", "chassis_nr", "brand", "model", "createdAt", "edit"],
            headers: {
                id: "Id",
                "authorized.full_name": "Ovlašćenik",
                registration_nr: "Registracija",
                chassis_nr: "Šasija",
                brand: "Marka",
                model: "Model",
                createdAt: "Datum",
                edit: "",
            },
            templates: {},
            actions: {
                btn1: {
                    color: "primary",
                    icon: "bi-pencil",
                    action: (data) => {
                        this.$router.push({
                            path: `/authorizations/${data.id}`,
                        });
                    },
                },
                print: {
                    color: "success",
                    icon: "bi-printer",
                    action: (data) => {
                        window.open(`/report/${data.id}/authorization/default`, '_blank');
                    },
                },
                delete: {
                    deleteData: this.deleteData,
                    color: "danger",
                    icon: "bi-trash",
                },
            },
            title: "",
        };
    },
    methods: {
        refreshData() {
            this.$refs.datatable.onRefresh();
        },
        addData() {
            this.$router.push({
                path: `/authorizations/0`,
            });
        },
        deleteData(data) {
            AuthorizationDataService.delete(data.id)
                .then((response) => {
                    this.$store.commit("app/showAlert", {
                        type: "success",
                        message: response.data.message,
                    });
                    this.$store.commit("app/hideModal");
                })
                .catch((e) => {
                    console.log(e);
                    this.$store.commit("app/showAlert", {
                        type: "danger",
                        message: e,
                    });
                });
        },
    },
};
</script>

<style scoped>
.list {
    text-align: left;
    margin: auto;
}
</style>
